module.exports = __webpack_public_path__ + "img/11_38.5cf5a236.png";